import { QueryClient } from '@tanstack/react-query';


export const queryClientInstance = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			refetchOnReconnect: false,
			// Retry 429 (rate-limit) errors up to 3 times with backoff so a
			// momentary spike doesn't leave the user with an empty screen.
			// Other errors retry once.
			retry: (failureCount, error) => {
				const status = error?.status || error?.response?.status;
				if (status === 429) return failureCount < 3;
				if (status >= 500 && status < 600) return failureCount < 2;
				return failureCount < 1;
			},
			retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10000),
			// Global default: cache queries for 5 minutes so navigating between
			// pages reuses data instead of re-fetching every entity on every
			// mount. This drastically reduces total entity-read volume and
			// prevents "App entity read traffic volume limit exceeded" errors.
			// Queries needing fresher data set their own shorter staleTime.
			staleTime: 1000 * 60 * 5,
			gcTime: 1000 * 60 * 30,
		},
	},
});